/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, November 18th 2021, 12:47:47 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";

export interface ToggleState {
  open: boolean;
  handleOpen: () => void;
  handleClose: () => void;
}

export const useToggleState = (initial: boolean = false) => {
  const [open, setOpen] = React.useState(initial);

  const handleOpen = React.useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, []);

  return { open, handleOpen, handleClose };
};
